import { render, staticRenderFns } from "./TurnoverStatisticComponent.vue?vue&type=template&id=5d914c3f&"
import script from "./TurnoverStatisticComponent.vue?vue&type=script&lang=js&"
export * from "./TurnoverStatisticComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports